import React, { useState, useContext } from "react";
import { Images } from "../../theme";
import "./styles.css";
import { AuthContext } from "../../context/AuthContext";
import { passwordRegex, emailRegex, DotsLoader } from "../../components";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Sociallogin from "./Sociallogin";

export default (props) => {
  const AuthData = useContext(AuthContext);
  const { handle_register, isLoading } = AuthData ? AuthData : null;

  const { t } = useTranslation();

  const [name, setName] = useState("");
  const [lastname, setLastname] = useState("");
  const [email, setEmail] = useState(""); //admin@gmail.com
  const [typePassword, setTypePassword] = useState("password");
  const [password, setPassword] = useState(""); // admin12345
  const [formErrors, setFormErrors] = useState({
    emailError: false,
    passwordError: false,
  });

  const renderShow = (typePassword) => {
    setTypePassword(typePassword == "password" ? "text" : "password");
  };

  const onChangeInput = async (data) => {
    data.state(data.value);
  };

  const checkValidation = () => {
    if (!name) {
      setFormErrors({ formErrors, firstError: t("First_Name_Field") });
    } else if (!lastname) {
      setFormErrors({
        formErrors,
        lastNameError: t("Last_Name_Field"),
      });
    } else if (!email) {
      setFormErrors({ formErrors, emailError: t("Required_Email") });
    } else if (!email.match(emailRegex)) {
      setFormErrors({ formErrors, emailError: t("Invalid_Email") });
    } else if (!password) {
      setFormErrors({
        formErrors,
        passwordError: t("Required_Password"),
      });
    } else if (!password.match(passwordRegex)) {
      setFormErrors({
        formErrors,
        passwordError: t("Password_Limit"),
      });
    } else {
      let payload = {
        firstname: name,
        lastname,
        email,
        password,
      };
      handle_register(payload, props);
    }
  };

  const renderName = () => {
    return (
      <div className="form-label-group mb-3">
        <div>
          <label>{t("First_Name")}</label>
          <input
            className="input-field"
            value={name}
            type="text"
            placeholder={t("First_Name")}
            onChange={(e) => {
              setFormErrors(false);
              onChangeInput({
                value: e.target.value,
                state: setName,
              });
            }}
          />
        </div>
        <div className="error_text">{formErrors.firstError}</div>
      </div>
    );
  };

  const renderLastName = () => {
    return (
      <div className="form-label-group mb-3">
        <div>
          <label>{t("Last_Name")}</label>
          <input
            className="input-field"
            value={lastname}
            type="text"
            placeholder={t("Last_Name")}
            onChange={(e) => {
              setFormErrors(false);
              onChangeInput({
                value: e.target.value,
                state: setLastname,
              });
            }}
          />
        </div>
        <div className="error_text">{formErrors.lastNameError}</div>
      </div>
    );
  };

  const renderEmail = () => {
    return (
      <div className="form-label-group mb-3">
        <div>
          <label>{t("Email")}</label>
          <input
            className="input-field"
            value={email}
            type="text"
            placeholder={t("Email")}
            onChange={(e) => {
              setFormErrors(false);
              onChangeInput({
                value: e.target.value,
                state: setEmail,
              });
            }}
          />
        </div>
        <div className="error_text">{formErrors.emailError}</div>
      </div>
    );
  };

  const renderPassword = () => {
    return (
      <div className="form-label-group">
        <label>{t("Password")}</label>
        <div>
          <input
            class="input-field"
            value={password}
            type={typePassword}
            placeholder={t("Password")}
            onChange={(e) => {
              setFormErrors(false);
              onChangeInput({
                value: e.target.value,
                state: setPassword,
              });
            }}
          />

          <div className="error_text">{formErrors.passwordError}</div>
        </div>
      </div>
    );
  };

  const renderLoginBtn = () => {
    return (
      <div className="mt-3" style={{ textAlign: "center" }}>
        <button
          type="button"
          className="btn-custom btn-light"
          style={{ width: "100%", borderRadius: 10, height: 50 }}
          onClick={() => checkValidation()}
        >
          {isLoading ? (
            <DotsLoader isloading={isLoading} color="#E8F0F2" />
          ) : (
            t("Sign_Up")
          )}
        </button>
      </div>
    );
  };

  const renderLoginForm = () => {
    return (
      <form action="javascript:void(0)" className="form-signin mt-4 px-2">
        <div className="d-flex justify-content-between">
          {renderName()}
          <div className="m-2" />
          {renderLastName()}
        </div>
        {renderEmail()}
        {renderPassword()}
        {renderLoginBtn()}
        <div className="d-flex justify-content-center text-14 my-2">
          <div className="text-14-bold pointer" style={{ color: "#212121" }}>
            {t("Or")}
          </div>
        </div>
        <Sociallogin />
        <div className="d-flex justify-content-center my-3">
          <div className="text-14 pointer" style={{ color: "#202122" }}>
            {t("Have_An_Account")}{" "}
            <Link to="" onClick={() => props.onPressForgot()}>
              <label className="pointer" style={{ color: "#005494" }}>
                {t("Sign_In")}
              </label>{" "}
            </Link>
          </div>
        </div>
      </form>
    );
  };

  const renderLoginCard = () => {
    return (
      <div className="card card-signin my-2 border-0">
        <div className="card-body">
          <h5 className="card-title text-center heading_title">
            {t("Sign_Up")}
          </h5>

          {renderLoginForm()}
        </div>
      </div>
    );
  };

  return (
    <div className="bg">
      <div className="center">
        <div
          className="container"
          style={{
            backgroundImage: `url(${Images.bg_image})`,
            borderRadius: 28,
            backgroundColor: "#E5E5E5",
          }}
        >
          <div className="row">
            <div className="d-flex justify-content-center my-3 pt-5">
              <img className="logo-icon" src={Images.logo_white} alt="image" />
            </div>

            <div className="col-sm-9 col-md-9 col-lg-5 mx-auto">
              {renderLoginCard()}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
